import { render, staticRenderFns } from "./f-boolean.vue?vue&type=template&id=bf671778&lang=pug&"
import script from "./f-boolean.vue?vue&type=script&lang=js&"
export * from "./f-boolean.vue?vue&type=script&lang=js&"
import style0 from "./f-boolean.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf671778')) {
      api.createRecord('bf671778', component.options)
    } else {
      api.reload('bf671778', component.options)
    }
    module.hot.accept("./f-boolean.vue?vue&type=template&id=bf671778&lang=pug&", function () {
      api.rerender('bf671778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/fields/f-boolean.vue"
export default component.exports